<template>
    <div
        class="bg-cover bg-center bg-no-repat px-3 sm:px-6 py-12 z-10"
        :style="{
            backgroundImage: `url('${require('@/assets/img/fondos_pinguiigluu.jpg')}')`
        }"
    >
        <div
            class="flex flex-col items-center w-full max-w-screen-sm mx-auto border-2 border-orange py-10 px-2 bg-white"
        >
            <logo class="mb-10"></logo>

            <p
                class="font-secondary text-blue mb-10 text-center"
                v-html="$config('REGION_NOT_AVAILABLE_MESSAGE')"
            ></p>

            <ValidationObserver
                v-if="!regionLockContactSent"
                v-slot="{ handleSubmit }"
                class="w-full"
            >
                <form
                    class="flex flex-col items-center w-3/4 mx-auto"
                    @submit.prevent="handleSubmit(sendForm)"
                    autocomplete="on"
                    novalidate
                >
                    <form-input
                        name="email"
                        type="email"
                        v-model="email"
                        :placeholder="$config('EMAIL')"
                        class="w-full mb-10"
                        required
                    ></form-input>

                    <form-input
                        name="country"
                        v-model="country"
                        class="w-full mb-10"
                        disabled
                    ></form-input>

                    <btn
                        class="bg-orange text-white text-xl rounded-large px-10 mb-8"
                        >{{ $config("ENVIAR") }}</btn
                    >
                </form>
            </ValidationObserver>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import store from "../store";
import Logo from "../components/Logo";
import Btn from "../components/Btn";
import FormInput from "../components/FormInput";
import requestWithInteractions from "../mixins/requestWithInteractions";
import api from "../api";

export default {
    name: "region-lock",

    components: { Logo, Btn, FormInput },

    mixins: [requestWithInteractions],

    beforeRouteEnter(to, from, next) {
        let { region } = store.state;

        if (region && region.status != "false") {
            next({ name: "home" });
        } else {
            next();
        }
    },

    data() {
        return {
            email: null
        };
    },

    computed: {
        ...mapState(["region", "regionLockContactSent"]),

        country() {
            if (!this.region) return "";

            return this.region.data.iso_country;
        }
    },

    methods: {
        sendForm() {
            this.sendRequest(api.regionLockContact(this.email, this.country), {
                beforeSendText: this.$config("SEND_MESSAGE"),
                successText: this.$config("SENDED_MESSAGE"),

                onSuccess: () => {
                    this.$store.commit("SET_REGION_LOCK_CONTACT_SENT", true);
                }
            });
        }
    }
};
</script>
